module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jckqM"))).then(() => parcelRequire('hEqeo'));